import {
  Component,
  ChangeDetectionStrategy,
  input,
  computed,
} from '@angular/core';
import { CurrencyPipe } from '@angular/common';
import { IconComponent } from '@gains-com/ui-angular';
import { PurchaseSelection } from '../../common';
import { CurrencyVM } from '../../../../core/payments-common.js';
import { GoldCoinsIconComponent } from '../../../coins/gold-coins-icon.component.js';
import { SweepsCoinsIconComponent } from '../../../coins/sweeps-coins-icon.component.js';
import { DecimalPipe } from '../../../../pipes/decimal.pipe.js';
import { PurchaseBoostBannerComponent } from '../purchase-boost-banner/purchase-boost-banner.component.js';
import { SweepsVisibleDirective } from '../../../../directives/sweeps-visible.directive.js';

@Component({
  selector: 'app-purchase-receipt',
  templateUrl: './purchase-receipt.component.html',
  styleUrl: './purchase-receipt.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    CurrencyPipe,
    DecimalPipe,
    GoldCoinsIconComponent,
    SweepsCoinsIconComponent,
    PurchaseBoostBannerComponent,
    IconComponent,
    SweepsVisibleDirective,
  ],
})
export class PurchaseReceiptComponent {
  package = input.required<PurchaseSelection>();
  currency = input<CurrencyVM | null>(null);
  convertedAmount = input<number | null>(null);

  cryptocurrency = computed(() => (this.currency()?.is_cryptocurrency ? this.currency() : null));

  amount = computed(() => this.package().inputAmount?.toNumber() ?? 0);

  goldAmountVM = computed(() => {
    const gcAwarded = this.package().gcAwarded;
    const digits = Math.min(Math.max(gcAwarded.decimalPlaces(), 2), 4);
    return gcAwarded.toNumber().toLocaleString('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  });

  sweepsAmountVM = computed(() => {
    const scAwarded = this.package().scAwarded;
    const digits = Math.min(Math.max(scAwarded.decimalPlaces(), 2), 4);
    return scAwarded.toNumber().toLocaleString('en-US', {
      minimumFractionDigits: digits,
      maximumFractionDigits: digits,
    });
  });
}
